import { formatMoney } from 'utils'
import { type MemberOnboardingProviderInNetworkMap } from 'utils/web_api.schemas'

import { type MedicalPlanDisplayItem } from '../medicalPlanTypes'
import { extractInNetworkAmount } from '../utils'
import { ProviderInNetworkMap } from './ProviderInNetworkMap'

interface DetailItemProps {
  label: string;
  value?: string;
}

function DetailItem ({ label, value }: DetailItemProps) {
  return (
    <>
      <dt className='text-gray-500 body-sm text-nowrap'>{label}</dt>
      <dd className='text-gray-800 body-bold text-right xs:text-left'>
        {value}
      </dd>
    </>
  )
}

interface MedicalPlanDetailSummaryProps {
  plan: MedicalPlanDisplayItem['plan'];
  isIndividual: boolean;
  providerInNetworkMap?: MemberOnboardingProviderInNetworkMap[];
  inNetworkProvidersCount?: number;
}

export function MedicalPlanDetailSummary ({
  plan,
  isIndividual,
  providerInNetworkMap,
  inNetworkProvidersCount,
}: MedicalPlanDetailSummaryProps) {
  const parsedDeductible = extractInNetworkAmount(
    isIndividual
      ? plan.individual_medical_deductible
      : plan.family_medical_deductible
  )

  const parsedMOOP = extractInNetworkAmount(
    isIndividual ? plan.individual_medical_moop : plan.family_medical_moop
  )

  return (
    <div className='flex flex-col xs:flex-row justify-between gap-4 mb-10 p-4 border border-gray-200 rounded-md shadow-md'>
      <dl className='grid grid-cols-2 gap-x-4 gap-y-2'>
        <DetailItem
          label={isIndividual ? 'Deductible' : 'Family deductible'}
          value={
              typeof parsedDeductible === 'string'
                ? parsedDeductible
                : formatMoney(parsedDeductible)
            }
        />
        <DetailItem
          label={
              isIndividual ? 'Out of pocket max' : 'Family out of pocket max'
            }
          value={
              typeof parsedMOOP === 'string'
                ? parsedMOOP
                : formatMoney(parsedMOOP)
            }
        />
        <DetailItem label='Network' value={plan.network_name} />
      </dl>
      {providerInNetworkMap && inNetworkProvidersCount !== undefined && (
        <ProviderInNetworkMap
          align='end'
          providerInNetworkMap={providerInNetworkMap}
          inNetworkProvidersCount={inNetworkProvidersCount}
          providerSupportLink={plan.provider_support_link}
        />
      )}
    </div>
  )
}
